import App from './App.svelte';
import './assets/main.css';
import './assets/numfont.css';

const app = new App({
	target: document.body
});

app.combination_sum = (m, n) =>{
	var temp_sum;
	var temp_i;
	temp_sum = 1;
	if (n == 0 || m > n) temp_sum = 0;
	if ((m != 0) && (m <= n) && (n != 0)) {
		if (2 * m < n) m = n - m;
		temp_i = m + 1;
		while (temp_i <= n) {
			temp_sum = temp_i * temp_sum;
			temp_i = temp_i + 1;
		}
		temp_i = n - m;
		while (temp_i > 1) {
			temp_sum = temp_sum / temp_i;
			temp_i = temp_i - 1;
		}
	}
	return temp_sum;
}

app.getRandomArrayElements = (arr, count) => {
	let shuffled = arr.slice(0),
		i = arr.length,
		min = i - count,
		temp, index;
	while (i-- > min) {
		index = Math.floor((i + 1) * Math.random());
		temp = shuffled[index];
		shuffled[index] = shuffled[i];
		shuffled[i] = temp;
	}
	return shuffled.slice(min);
}

app.getRandOne = (arr) => {
	var index = Math.floor((Math.random()*arr.length));
	return arr[index];
}

app.setTitle = (title) => {
	var ua = navigator.userAgent.toLowerCase();
    var isWeixin = ua.indexOf('micromessenger') != -1;

    if (!isWeixin) {
		document.title = title;
    }
}

export default app;